import { render, staticRenderFns } from "./SiInputCheckbox.vue?vue&type=template&id=52dcf808&scoped=true&lang=html&"
import script from "./SiInputCheckbox.vue?vue&type=script&lang=js&"
export * from "./SiInputCheckbox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52dcf808",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
installComponents(component, {VCheckbox})
